module.exports = __webpack_public_path__ + "img/Career Readiness.e102901b.png";